import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { installErrorCapture } from "./utils/clientErrors";

installErrorCapture();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

/**
 * The register is installed on a shop's tablet and has to survive the
 * connection dropping, so the app shell is cached. API calls are never cached
 * — see public/service-worker.js.
 */
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {
      // Without it the app still works; it just will not open offline
    });
  });
}
